import React from "react";
import Cluster from "layout/Cluster";
import Menu from "./MenuListComposition";
import styled from "styled-components";
import { appMenuItems } from "./model/commonMenuData";

const MainNav = styled(Cluster)`
  margin-top: 1rem;
`;

const SiteMenu = () => {
  return (
    <MainNav element="nav" justify="end" gap="xs">
      {appMenuItems.map((menu, index) => {
        return (
          <Menu menuTitle={menu.name} menuItems={menu.items} key={index} />
        );
      })}
    </MainNav>
  );
};

export default SiteMenu;
